import 'bootstrap';
import PDFObject from 'pdfobject';

function registerPdfModalLinks(): void {
  if (PDFObject.supportsPDFs) {
    document.addEventListener('click', event => {
      let target = event.target as HTMLAnchorElement
      if (target && target.href && target.href.includes('.pdf')) {
        target.dataset.bsToggle = 'modal'
        target.dataset.bsTarget = '#pdfModal'
        target.dataset.pdfUrl = target.href
        target.href = '#'
        event.preventDefault()
        target.click()
      }
    })
  }
}

function handlePdfModalEvents(): void {
  const pdfModalElement = document.getElementById('pdfModal');
  const pdfModalContentElement = document.getElementById('pdfModalContent');

  if (pdfModalElement && pdfModalContentElement) {
    pdfModalElement.addEventListener('show.bs.modal', (event: Event & { relatedTarget: HTMLElement }) => {
      const relatedTarget = event.relatedTarget;
      if (relatedTarget) {
        const url = relatedTarget.dataset.pdfUrl;
        PDFObject.embed(url, pdfModalContentElement);
      }
    });

    pdfModalElement.addEventListener('hidden.bs.modal', () => {
      pdfModalContentElement.innerHTML = '';
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  registerPdfModalLinks();
  handlePdfModalEvents();
});
